import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Button as UiButton, buttonClasses, type ButtonVariant as UiVariant } from '../../ui/Button.js';

/**
 * Compatibilité : boutons historiques de l'espace garage, désormais rendus par `src/ui/Button`.
 * Pleine largeur par défaut (usage au pouce). Code neuf : importer `Button` depuis `src/ui`.
 */
export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

const MAP: Record<ButtonVariant, UiVariant> = {
  primary: 'primary',
  secondary: 'secondary',
  danger: 'danger',
  ghost: 'quiet',
};

export function buttonClass(variant: ButtonVariant = 'primary', block = true, extra = ''): string {
  return buttonClasses({ variant: MAP[variant], size: 'md', block, className: extra });
}

export function Button({
  variant = 'primary',
  block = true,
  busy = false,
  className = '',
  children,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  block?: boolean;
  busy?: boolean;
  children: ReactNode;
}) {
  return (
    <UiButton variant={MAP[variant]} block={block} loading={busy} className={className} {...rest}>
      {children}
    </UiButton>
  );
}
